import GET_ARTICLES from "./getArticles"
import moment from "moment"
import 'moment/locale/ja'

const dateTable = {'a':1,'b':11,'c':21}

const isBetween = (m,s,e) => m.isBetween(s,e,'date','[)')


export default function GET_FRUITS() {
  $.getJSON('/asset/json/fruits_list.json').done((fruits_list,st,xhr) => {
    const m = moment(xhr.getResponseHeader('date'))
    const seasonFruits = []
    fruits_list.forEach(item => {
      const start_arr = item.season[0].split('-') // シーズンコードを配列に変換
      const end_arr = item.season[1].split('-') // シーズンコードを配列に変換
      // シーズンコードから開始と終了のMomentオブジェクトを生成
      const start = moment().set({'month': start_arr[0] - 1, 'date': dateTable[start_arr[1]] })
      const end = moment().set({'month': end_arr[0] - 1, 'date': dateTable[end_arr[1]] })
      // 年またぎだったら
      if(parseInt(start_arr[0]) > parseInt(end_arr[0])){
        if(m.isBefore(end)) start.subtract(1, 'years') // まだ終了日を迎えていない場合、開始日は去年です
        if(m.isAfter(end)) end.add(1, 'years') // 今年の終了日が過ぎている場合、終了日は来年です
      }
      // 今日が開始日と終了日の期間内であればtrue, 開始日と終了日が一緒（通年）の場合もtrue
      if(isBetween(m,start,end) || start.isSame(end,'date')) seasonFruits.push(item.id)
    })
  
    if(seasonFruits.length == 0){
      $('[data-name="topFruit"]').children('p').html('現在お取り扱いできる旬の商品を準備しております。')
    }else{
  
      GET_ARTICLES('[data-name="topFruit"]',{
        articles: seasonFruits.join(','),
        prefix:'p-block-fruit__',
        makeItem(item,opt){
          const thumb = (item.thumb.length>1)?item.thumb:'/image/underconstruction.gif'
          return $(`
            <a href="${item.href}" class="${opt.prefix}item">
              <figure class="${opt.prefix}item__img">
                <div class="${opt.prefix}item__img-inner" style="background-image:url(${thumb})">
                  <img src="${thumb}" alt="${item.title}" />
                </div>
              </figure>
              <span class="${opt.prefix}item__name">${item.title}</span>
            </a>
          `)[0]
        }
      })
    }
    
  })
}
